import { RecorderPosition } from 'modules/video-markers/domain/interfaces';

/** vMix отдаёт длительность записи целыми секундами (`<recording duration="12">`). */
export const VMIX_PRECISION_MS = 1000;

export const VMIX_TRUE = 'True';

/**
 * Состояние vMix из XML его Web API (`GET /api`) → позиция программы.
 *
 * Снято с vMix 28 (фикстуры в `__tests__/fixtures/`): запись — `<recording duration="12"
 * filename1="…">True</recording>`, без записи — `False` и без `duration`, но с `filename1`
 * прошлого файла (поэтому путь берётся только у идущей записи); эфир —
 * `<streaming channel1="True">True</streaming>`. **Длительности эфира vMix не отдаёт вовсе**,
 * поэтому `streamingMs` у vMix всегда `null`. Паузы записи у vMix нет (`PauseRecording` — «No
 * suitable Function»).
 *
 * Не XML vMix (страница ошибки, пустой ответ) — исключение: молча вернуть «запись не идёт»
 * значило бы спрятать поломку.
 */
export function parseVmixState(xml: string): RecorderPosition {
  const root = parseVmixRoot(xml);
  const recording = Array.from(root.children).find((element) => element.nodeName === 'recording');
  const isRecording = recording?.textContent?.trim() === VMIX_TRUE;
  const durationSeconds = Number(recording?.getAttribute('duration') ?? 0);

  if (isRecording && !Number.isFinite(durationSeconds)) {
    throw new Error('vMix вернул длительность записи не числом');
  }

  return {
    recordingMs: isRecording ? durationSeconds * VMIX_PRECISION_MS : null,
    recordingPaused: false,
    recordingFile: isRecording ? recording?.getAttribute('filename1') || null : null,
    streamingMs: null,
    precisionMs: VMIX_PRECISION_MS,
  };
}

/** Корень XML состояния vMix (`<vmix>`); не XML vMix — исключение. */
export function parseVmixRoot(xml: string): Element {
  const root = new DOMParser().parseFromString(xml, 'text/xml').documentElement;

  if (root?.nodeName !== 'vmix') {
    throw new Error('Ответ vMix — не XML состояния (<vmix>)');
  }

  return root;
}
